import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapNorthAmerica from '../../components/map/map.northAmerica';
import MapUnitedStates from '../../components/map/map.unitedStates';
import MapCanada from '../../components/map/map.canada';
import MapMexico from '../../components/map/map.mexico';
import Card from '../../components/card';
import observeRootStore from '../../components/hoc/observeRootStore';
import * as constants from '../../appConstants';
import './mapContainer.scss';

class MapContainer extends Component {
    constructor() {
        super();
        this.viewOverview = this.viewOverview.bind(this);
    }

    viewOverview() {
        this.props.rootStore.uiStore.selectedState = null;
        this.props.rootStore.uiStore.activeMap = constants.NORTH_AMERICA;
        this.props.rootStore.uiStore.selectedFilter = constants.FILTER_ALL;
    };

    render() {
        const { rootStore } = this.props;
        const activeMap = rootStore.uiStore.activeMap;
        return (
            <div className="map-container">
                {rootStore.uiStore.selectedState && <Card />}
                {activeMap === constants.NORTH_AMERICA && <MapNorthAmerica />}
                {activeMap === constants.UNITED_STATES && (
                    <MapUnitedStates
                        stateListData={rootStore.opsMapCountries[constants.UNITED_STATES]}
                    />
                )}
                {activeMap === constants.CANADA && (
                    <MapCanada
                        stateListData={rootStore.opsMapCountries[constants.CANADA]}
                    />
                )}
                {activeMap === constants.MEXICO && (
                    <MapMexico
                        stateListData={rootStore.opsMapCountries[constants.MEXICO]}
                    />
                )}
                {activeMap !== constants.NORTH_AMERICA && (
                    <button className="btn overview-toggle" onClick={this.viewOverview}>Home</button>
                )}
            </div>
        );
    }
}


MapContainer.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedState: PropTypes.object,
            activeMap: PropTypes.string.isRequired,
            selectedFilter: PropTypes.string.isRequired,
        }).isRequired,
        opsMapCountries: PropTypes.objectOf(
            PropTypes.object
        ).isRequired,
    }).isRequired,
};

export default observeRootStore(MapContainer);
